<template>
  <div class="lab-progress-bar my-2">
    <div class="progress-container">
      <div class="overall-progress">
        <div class="progress border border-secondary shadow-sm">
          <div
            class="progress-bar bg-secondary"
            role="progressbar"
            aria-label="Lab progress"
            :style="{ width: overallProgress + '%' }"
            :aria-valuenow="overallProgress"
            aria-valuemin="0"
            aria-valuemax="100"
          >
            {{ overallProgress }}%
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LabProgressBar",
  props: {
    currentPassage: {
      type: String,
      default: "start"
    },
    context: {
      type: Object,
      default: () => ({})
    },
    /** From each lab's `labManifest.progressSteps` */
    progressSteps: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    storyProgress() {
      const steps = this.progressSteps;
      const currentIndex = steps.findIndex(
        (step) => step.id === this.currentPassage
      );
      const current = currentIndex >= 0 ? currentIndex + 1 : 1;
      const total = Math.max(steps.length, 1);
      const percentage = Math.round((current / total) * 100);

      return {
        current,
        total,
        percentage
      };
    },

    overallProgress() {
      return this.storyProgress.percentage;
    }
  }
};
</script>

<style scoped>
.lab-progress-bar {
  width: 200px;
}
</style>
